// extracted by mini-css-extract-plugin
module.exports = {"modal-container":"LoadingModal_modal-container__3PfCN","spin-container":"LoadingModal_spin-container__1tqXS","text-container":"LoadingModal_text-container__3HE0R"};